import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useEffect, useState } from 'react';

const moment = require('moment');

const TypeDuration = ({
  field,
  updateValidationOnChange,
  dataCollection,
  errors,
  size,
}) => {
  const [time, setTime] = useState(null);

  useEffect(() => {
    setTime(secondsToMomentToday(dataCollection[field.key]));
  }, [dataCollection]);

  // handle input changes
  function handleDateChange(newTime) {
    updateValidationOnChange(field.key, momentToSeconds(newTime));
  }

  function secondsToMomentToday(seconds) {
    return moment().startOf('day').add(seconds, 'seconds');
  }

  function momentToSeconds(momentObj) {
    return momentObj.diff(momentObj.clone().startOf('day'), 'seconds');
  }

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <TimePicker
        className="w-full"
        onChange={handleDateChange}
        value={time}
        label={field.label}
        ampm={false}
        slotProps={{ textField: { size } }}
      />
    </LocalizationProvider>
  );
};

export default TypeDuration;
